import Layout from "components/generics/Layout";
import { createUseStyles } from "react-jss";
import ReactMarkdown from "react-markdown";
import { getTermsAndConditions } from "./api";
import BlueFooter from 'components/styledComponents/BlueFooter';
import clsx from "clsx";

const useStyles = createUseStyles({
    container: {
        padding: "10px",
    },
})

function TermsAndConditions({
    meta,
    tnc
}) {

    const classes = useStyles();

    return (
        <Layout
            meta={meta}
        >
            <div className={clsx("max-width", classes.container)}>
                <ReactMarkdown
                    source={tnc}
                />
            </div>
            <BlueFooter
                footer
            />
        </Layout>
    )
}

export async function getStaticProps() {
    const data: any = await getTermsAndConditions();

    return {
        props: {
            meta: data.data.meta,
            tnc: data.data.tnc,
        },
    };
}

export default TermsAndConditions;